import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { STORAGE_KEY } from '@/common/hooks/useGoogleScope';
import handleException from '@/common/utils/errors';

export const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const storedState = localStorage.getItem('oauth_state');

      // Verify state to prevent CSRF attacks
      if (state !== storedState) {
        handleException('State mismatch');
        navigate('/');
        return;
      }

      if (code) {
        try {
          const response = await fetch('https://oauth2.googleapis.com/token', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
              code,
              client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
              client_secret: import.meta.env.VITE_GOOGLE_CLIENT_SECRET,
              redirect_uri: `${window.location.origin}/google/auth/callback`,
              grant_type: 'authorization_code',
            }),
          });

          if (!response.ok) {
            throw new Error('Failed to exchange code for token');
          }

          const data = await response.json();

          // Store the tokens
          const tokenData = {
            accessToken: data.access_token,
            refreshToken: data.refresh_token,
            expiryDate: Date.now() + (data.expires_in * 1000),
          };

          localStorage.setItem(STORAGE_KEY, JSON.stringify(tokenData));

          // Clean up state
          localStorage.removeItem('oauth_state');

          // Redirect to main app
          navigate('/');
        } catch (error) {
          handleException(error);
          navigate('/');
        }
      }
    }

    handleCallback();
  }, [navigate]);

  return <div>Processing authentication...</div>;
}
